import { SetRoutes } from 'components';
import routes from './routes';

const PrestigeLevelsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default PrestigeLevelsPages;
